// Notice-mode activities that share the evidence → pattern → confirm engine.
export const EVIDENCE_MAPS = {
  "strengths-evidence-map": {
    prefix: "strengths-map", evidenceField: "strengths_evidence", mapField: "strengths_map",
    stage: "What I bring", title: "Strengths Evidence Map", minutes: 12,
    opening: "Not the strengths on your CV. The ones people quietly rely on you for.",
    aside: "Spark won't name a strength because you named it. It looks for what you actually did, more than once, and shows you the evidence before asking whether it's true.",
    noun: "strength", nounPlural: "strengths",
    reflectTitle: "Eight kinds of example. Rough is fine — specifics matter more than polish.",
    noticeTitle: "Possible strengths — each one shown with what it rests on.",
    kindLabels: { strength: "Possible strength", tension: "A tension worth noticing" },
    heldFields: ["strengths"],
    next: { key: "achievement-mining", title: "Achievement Mining" },
  },
  "energy-map": {
    prefix: "energy-map", evidenceField: "energy_evidence", mapField: "energy_map",
    stage: "What I bring", title: "Energy Map", minutes: 10,
    opening: "Energy tends to tell the truth before we're ready to say it.",
    aside: "Being good at something isn't the same as being fed by it. Spark looks for what reliably gives and reliably drains — and where the two pull against each other.",
    noun: "energy pattern", nounPlural: "energy patterns",
    reflectTitle: "Eight moments. Not what you should feel — what you actually noticed.",
    noticeTitle: "What seems to give, what seems to drain — and where they pull against each other.",
    kindLabels: { gives: "Seems to give you energy", drains: "Seems to drain you", tension: "A tension worth noticing" },
    heldFields: ["energy_sources", "energy_drains"],
    next: { key: "strengths-evidence-map", title: "Strengths Evidence Map" },
  },
  "values-in-action": {
    prefix: "values-map", evidenceField: "values_evidence", mapField: "values_map",
    stage: "Unblock thinking", title: "Values in Action", minutes: 10,
    opening: "Values show up most clearly when something is missing.",
    aside: "A value only counts when you've paid for it — protected it, refused something, got angry. Spark looks for those moments, and for the places where two things you care about pull against each other.",
    noun: "value", nounPlural: "values",
    reflectTitle: "Eight moments where something mattered. Choices and reactions, not principles.",
    noticeTitle: "Values in action — and the tensions between them, left open.",
    kindLabels: { value: "Possible value", tension: "A tension worth noticing" },
    heldFields: ["values"],
    next: { key: "confidence-inner-narrative", title: "Confidence & Inner Narrative" },
  },
};

export const HELD_FIELD_LABELS = {
  strengths: "My Strengths", energy_sources: "What gives me energy", energy_drains: "What drains me", values: "My Values", tensions: "Tensions I'm holding",
};
